export default {
  path: '/profile_files',
  name: 'profile_files',
  component: () => import('../components/profilefile/Layout'),
  redirect: { name: 'ProfileFileList' },
  meta: {
    breadcrumb: 'profile.profilefiles',
  },
  children: [
    {
      name: 'ProfileFileList',
      path: '',
      component: () => import('../views/profilefile/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProfileFileUtils',
      path: 'utils',
      component: () => import('../views/profilefile/Utils'),
      meta: {
        breadcrumb: 'profile.profilefilesutils',
      },
    },
    {
      name: 'ProfileFileCreate',
      path: 'new',
      component: () => import('../views/profilefile/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProfileFileUpdate',
      path: ':id/edit',
      component: () => import('../views/profilefile/Update'),
      meta: {
        breadcrumb: 'profile.profile',
      },
    },
    {
      name: 'ProfileFileShow',
      path: ':id',
      component: () => import('../views/profilefile/Show'),
      meta: {
        breadcrumb: 'profile.profilefile',
      },
    }
  ]
};
